export const DefaultImage =
  "https://cdn.1cdn.app/application/UMD/2405110558455_logo.png";
